import { Grid } from '@naf/grid';
import styled from 'styled-components';
import { Text } from '@naf/text';
import { Link } from 'react-router-dom';
import { nafColor } from '@nafcore/theme';
import { breakpoints, spacing } from '@naf/theme';
import ContactBox from '../../components/ContactBox';
import BenefitsGrid from '../../../../components/benefits-list/BenefitsGrid';

export const GridWrapper = styled(Grid)`
  grid-gap: 0;
  column-gap: ${spacing.space32};

  h1 {
    margin-top: ${spacing.space24};
    margin-bottom: -${spacing.space8};
  }

  @media (max-width: ${breakpoints.m}) {
    grid-template-columns: 1fr;
  }
`;

export const ContactWrapper = styled(Grid)`
  grid-gap: 0;
  column-gap: ${spacing.space32};
  margin-bottom: ${spacing.space80};

  @media (max-width: ${breakpoints.m}) {
    grid-template-columns: 1fr;
    gap: ${spacing.space32};
  }
`;

export const FacebookPlaceholder = styled.div`
  grid-column: 1 / 6;
  height: ${spacing.space32};
  margin-bottom: ${spacing.space32};

  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;

export const EventHeader = styled(Text)`
  margin: ${spacing.space64} 0 ${spacing.space32} 0;
`;

export const Facebook = styled.div`
  grid-column: 1 / 6;
  margin-bottom: ${spacing.space40};
  @media (max-width: ${breakpoints.m}) {
    grid-column: 1;
  }
`;

export const Header = styled(Text)`
  grid-column: 1 / 10;
  @media (max-width: ${breakpoints.m}) {
    grid-row: 2;
    grid-column: 1;
  }
`;

export const YellowLine = styled.div`
  background-color: ${nafColor.signature.yellow};
  width: 126px;
  height: 4px;
  margin-bottom: ${spacing.space56};
`;

export const Ingress = styled(Text)`
  grid-column: 1 / 10;
  grid-row: 2;
  font-style: italic;

  @media (max-width: ${breakpoints.m}) {
    grid-row: 3;
    grid-column: 1;
  }
`;

export const BodyContainer = styled.div`
  grid-column: 1 / 10;
  margin: 0 0 ${spacing.space32} 0;
  @media (max-width: ${breakpoints.m}) {
    grid-column: 1;
  }
`;

export const Picture = styled.img`
  grid-row: 1/4;
  grid-column: 10/13;
  justify-self: end;
  height: 253px;
  width: 100%;
  margin-top: ${spacing.space32};
  object-fit: contain;

  @media (max-width: ${breakpoints.m}) {
    grid-row: 1;
    grid-column: 1;
    justify-self: start;
    width: 100%;
    margin-top: ${spacing.space24};
  }
`;

export const StyledContactBox = styled(ContactBox)`
  grid-column: 1 / 5;
  background-color: ${nafColor.primary.dew};

  @media (max-width: ${breakpoints.m}) {
    grid-column: 1;
  }
`;

export const StyledEntryCard = styled.div`
  grid-column: auto / span 4;

  @media (max-width: ${breakpoints.m}) {
    grid-column: 1;
  }
`;

export const StyledBenefitsGrid = styled(BenefitsGrid)`
  margin-bottom: ${spacing.space40};
`;

export const StyledText = styled(Text)`
  margin-bottom: ${spacing.space24};
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;

export const ShowMoreButtonWrapper = styled.div`
  display: flex;
  align-items: center;

  button {
    margin-right: ${spacing.space20};
  }
`;
